import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CouponMiddleware from 'yoda-site-components/lib/middlewares/CouponMiddleware';
import StyliticsMiddleware from 'yoda-site-components/lib/middlewares/StyliticsMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import AnalyticsMiddleware from './AnalyticsMiddleware';
import IrisMiddleware from './IrisMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    AnalyticsMiddleware,
    IrisMiddleware,
    MiniPDPAnalyticsMiddleware,
    CouponMiddleware,
    StyliticsMiddleware,
];

export default rootMiddleware;
